// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
  position: relative;
  min-width: 180px;
  -webkit-user-select: none;
          user-select: none;
}

/* Trigger button */
.cs-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  background: var(--white);
  border: 1.5px solid rgba(200, 134, 10, 0.22);
  border-radius: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-mid);
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  white-space: nowrap;
}

.cs-trigger:hover {
  border-color: var(--gold);
  color: var(--gold-dark);
  box-shadow: 0 2px 12px rgba(200, 134, 10, 0.1);
}

.custom-select.open .cs-trigger {
  border-color: var(--gold);
  color: var(--gold-dark);
  box-shadow: 0 0 0 3px rgba(200, 134, 10, 0.1);
}

.cs-value {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cs-chevron {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: var(--gold);
  transition: transform 0.25s ease;
}

.custom-select.open .cs-chevron {
  transform: rotate(180deg);
}

/* Dropdown panel */
.cs-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: var(--white);
  border: 1.5px solid rgba(200, 134, 10, 0.2);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(200, 134, 10, 0.15), 0 2px 8px rgba(0,0,0,0.06);
  z-index: 200;
  overflow: hidden;
  opacity: 0;
  transform: translateY(-6px) scale(0.98);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  max-height: 280px;
  overflow-y: auto;
}

.custom-select.open .cs-dropdown {
  opacity: 1;
  transform: translateY(0) scale(1);
  pointer-events: all;
}

/* Scrollbar */
.cs-dropdown::-webkit-scrollbar { width: 4px; }
.cs-dropdown::-webkit-scrollbar-track { background: transparent; }
.cs-dropdown::-webkit-scrollbar-thumb { background: rgba(200, 134, 10, 0.3); border-radius: 4px; }

/* Options list */
.cs-list {
  list-style: none;
  padding: 6px;
}

.cs-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 0.88rem;
  font-weight: 500;
  color: var(--text-mid);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.cs-option:hover {
  background: rgba(200, 134, 10, 0.07);
  color: var(--gold-dark);
}

.cs-option.selected {
  background: linear-gradient(135deg, rgba(200, 134, 10, 0.12), rgba(196, 72, 10, 0.06));
  color: var(--gold-dark);
  font-weight: 600;
}

.cs-check {
  width: 14px;
  height: 14px;
  color: var(--gold);
  flex-shrink: 0;
}

.cs-option:not(.selected) .cs-check {
  display: none;
}

.cs-option:not(.selected) {
  padding-left: 12px;
}

.cs-option.selected {
  padding-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,4CAA4C;EAC5C,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,wBAAwB;EACxB,2CAA2C;EAC3C,mBAAmB;EACnB,2EAA2E;EAC3E,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,oBAAoB;EACpB,kDAAkD;EAClD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,cAAc;AACd,kCAAkC,UAAU,EAAE;AAC9C,wCAAwC,uBAAuB,EAAE;AACjE,wCAAwC,mCAAmC,EAAE,kBAAkB,EAAE;;AAEjG,iBAAiB;AACjB;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,sFAAsF;EACtF,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".custom-select {\n  position: relative;\n  min-width: 180px;\n  user-select: none;\n}\n\n/* Trigger button */\n.cs-trigger {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 16px;\n  background: var(--white);\n  border: 1.5px solid rgba(200, 134, 10, 0.22);\n  border-radius: 10px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: var(--text-mid);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.cs-trigger:hover {\n  border-color: var(--gold);\n  color: var(--gold-dark);\n  box-shadow: 0 2px 12px rgba(200, 134, 10, 0.1);\n}\n\n.custom-select.open .cs-trigger {\n  border-color: var(--gold);\n  color: var(--gold-dark);\n  box-shadow: 0 0 0 3px rgba(200, 134, 10, 0.1);\n}\n\n.cs-value {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cs-chevron {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: var(--gold);\n  transition: transform 0.25s ease;\n}\n\n.custom-select.open .cs-chevron {\n  transform: rotate(180deg);\n}\n\n/* Dropdown panel */\n.cs-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  background: var(--white);\n  border: 1.5px solid rgba(200, 134, 10, 0.2);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(200, 134, 10, 0.15), 0 2px 8px rgba(0,0,0,0.06);\n  z-index: 200;\n  overflow: hidden;\n  opacity: 0;\n  transform: translateY(-6px) scale(0.98);\n  pointer-events: none;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.custom-select.open .cs-dropdown {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n  pointer-events: all;\n}\n\n/* Scrollbar */\n.cs-dropdown::-webkit-scrollbar { width: 4px; }\n.cs-dropdown::-webkit-scrollbar-track { background: transparent; }\n.cs-dropdown::-webkit-scrollbar-thumb { background: rgba(200, 134, 10, 0.3); border-radius: 4px; }\n\n/* Options list */\n.cs-list {\n  list-style: none;\n  padding: 6px;\n}\n\n.cs-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 0.88rem;\n  font-weight: 500;\n  color: var(--text-mid);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.cs-option:hover {\n  background: rgba(200, 134, 10, 0.07);\n  color: var(--gold-dark);\n}\n\n.cs-option.selected {\n  background: linear-gradient(135deg, rgba(200, 134, 10, 0.12), rgba(196, 72, 10, 0.06));\n  color: var(--gold-dark);\n  font-weight: 600;\n}\n\n.cs-check {\n  width: 14px;\n  height: 14px;\n  color: var(--gold);\n  flex-shrink: 0;\n}\n\n.cs-option:not(.selected) .cs-check {\n  display: none;\n}\n\n.cs-option:not(.selected) {\n  padding-left: 12px;\n}\n\n.cs-option.selected {\n  padding-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
